/* eslint-disable no-fallthrough */
/* eslint-disable react/display-name */
import React from 'react';
import dotProp from 'dot-prop-immutable';
import { Button, Avatar } from 'antd';
import classNames from 'classnames';

import { GLOBAL_UPDATE_MESSAGE } from '../page_details/actiontypes';
import { getAvatarBgClass } from '../../config/utils';
import * as actionTypes from './actiontypes';
import states from './states';

const users_details = (state = states.users_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_USERS_STATE: {
      return dotProp.set(state, action.path, action.payload);
    }

    case actionTypes.USERS_AND_COLUMNS_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          users_and_columns_loading: true,
          users_and_columns_loaded: false,
        }
      };
    }

    case actionTypes.USERS_AND_COLUMNS_LOADED: {
      let users_table_columns = [...state.users_table_columns];
      let users = [...state.users];
      if (action.payload.userTableColumns && action.payload.users) {
        action.payload.userTableColumns.forEach((col) => {
          if (col.dataIndex && col.dataIndex === 'name') {
            col.render = (name, record) => {
              const avatarBgClass = getAvatarBgClass(name);
              const avatarProps = record.imgUrl && record.imgUrl.trim().length > 0 ? { src: record.imgUrl, alt: "U" } : {};
              return (
                <span>
                  <Avatar size='small' className={record.imgUrl && record.imgUrl.trim().length > 0 ? "" : classNames({ ...avatarBgClass })} {...avatarProps}>{name.charAt(0)}</Avatar>
                  <span className="ori-l-pad-10 ori-capitalize ori-font-bold">{name}</span>
                </span>
              );
            }
          }
        });
        users = [...action.payload.users];
        users_table_columns = [
          ...action.payload.userTableColumns,
          {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            render: (text, record) => <Button type="primary" size="small" className="ori-border-radius-15 ori-lr-pad-10 ori-font-xs" onClick={() => action.viewUserProfile(record)} >View Profile</Button>,
          }
        ];
      }
      return {
        ...state,
        users,
        users_table_columns,
        users_table_pagination: {
          ...state.users_table_pagination,
          more_pages: action.payload.users.length === 10,
        },
        loaders: {
          ...state.loaders,
          users_and_columns_loading: false,
          users_and_columns_loaded: true,
        }
      };
    }

    case actionTypes.USERS_AND_COLUMNS_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          users_and_columns_loading: false,
          users_and_columns_loaded: false,
        }
      };
    }

    case actionTypes.USERS_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          users_loading: true,
          users_load_error: false,
        }
      };
    }

    case actionTypes.USERS_LOADED: {
      return {
        ...state,
        users: action.payload.users ? action.payload.users : [...state.users],
        users_table_pagination: {
          ...state.users_table_pagination,
          more_pages: action.payload.users.length === 10,
        },
        loaders: {
          ...state.loaders,
          users_loading: false,
          users_load_error: false,
        }
      };
    }

    case actionTypes.USERS_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          users_loading: false,
          users_load_error: true,
        }
      };
    }

    case actionTypes.USER_INFO_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          user_info_loading: true,
          user_info_loaded: false,
        }
      };
    }

    case actionTypes.USER_INFO_LOADED: {
      return {
        ...state,
        user_profile: {
          ...state.user_profile,
          basic_info: { ...action.payload },
        },
        loaders: {
          ...state.loaders,
          user_info_loading: false,
          user_info_loaded: true,
        }
      };
    }

    case actionTypes.USER_INFO_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          user_info_loading: false,
          user_info_loaded: false,
        }
      };
    }

    case actionTypes.USER_STATS_LOADING_START: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          stats_loading: true,
        }
      };
    }

    case actionTypes.USER_STATS_LOADING_END: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          stats_loading: false,
        }
      };
    }

    case actionTypes.USER_STATS_LOADED: {
      return {
        ...state,
        user_profile: {
          ...state.user_profile,
          stats: action.payload.userAnalyticsCount ? [...action.payload.userAnalyticsCount] : []
        }
      };
    }

    case actionTypes.USER_EVENT_HISTOGRAM_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          event_histogram_loading: true,
          event_histogram_load_error: false,
        }
      };
    }

    case actionTypes.USER_EVENT_HISTOGRAM_LOADED: {
      return {
        ...state,
        user_profile: {
          ...state.user_profile,
          event_histogram: action.payload.userEventHistogram ? action.payload.userEventHistogram : [],
        },
        loaders: {
          ...state.loaders,
          event_histogram_loading: false,
          event_histogram_load_error: false,
        }
      };
    }

    case actionTypes.USER_EVENT_HISTOGRAM_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          event_histogram_loading: false,
          event_histogram_load_error: true,
        }
      };
    }

    case actionTypes.CHATLOG_LIST_FILTERS_LOADED: {
      return {
        ...state,
        user_profile: {
          ...state.user_profile,
          chatlog_list_filters: action.payload ? action.payload : []
        }
      };
    }

    case actionTypes.USER_CHATLOG_LIST_LOADING_START: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          chatlog_list_loading: true,
        }
      };
    }

    case actionTypes.USER_CHATLOG_LIST_LOADING_END: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          chatlog_list_loading: false,
        }
      };
    }

    case actionTypes.USER_CHATLOG_LIST_LOADED: {
      return {
        ...state,
        user_profile: {
          ...state.user_profile,
          chatlog_list: action.payload.chatSessions ? action.payload.chatSessions : [],
          chatlog_list_pagination: {
            ...state.user_profile.chatlog_list_pagination,
            load_more: action.payload.chatSessions && action.payload.chatSessions.length === state.user_profile.chatlog_list_pagination.required,
            total: action.payload.totalCount ? action.payload.totalCount : 0,
          },
          active_chatlog_details: {
            visible: false,
            chatlog_item: null,
            messages: [],
            chat_profile: {},
          }
        }
      };
    }

    case actionTypes.MORE_USER_CHATLOG_LIST_LOADED: {
      return {
        ...state,
        user_profile: {
          ...state.user_profile,
          chatlog_list: action.payload.chatSessions ? [...state.user_profile.chatlog_list, ...action.payload.chatSessions] : [...state.user_profile.chatlog_list],
          chatlog_list_pagination: {
            ...state.user_profile.chatlog_list_pagination,
            load_more: action.payload.chatSessions && action.payload.chatSessions.length === state.user_profile.chatlog_list_pagination.required,
            total: action.payload.totalCount ? action.payload.totalCount : 0,
          }
        }
      };
    }

    case actionTypes.USER_CHATLOG_LIST_LOAD_ERROR: {
      return {
        ...state,
        user_profile: {
          ...state.user_profile,
          chatlog_list: [],
          chatlog_list_pagination: {
            ...state.user_profile.chatlog_list_pagination,
            load_more: false,
            total: 0,
          },
          active_chatlog_details: {
            visible: false,
            chatlog_item: null,
            messages: [],
            chat_profile: {},
          }
        }
      };
    }

    case actionTypes.ACTIVE_CHATLOG_DETAILS_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          active_chatlog_details_loading: true,
          active_chatlog_details_load_error: false,
        }
      };
    }

    case actionTypes.ACTIVE_CHATLOG_DETAILS_LOADED: {
      return {
        ...state,
        user_profile: {
          ...state.user_profile,
          active_chatlog_details: {
            visible: true,
            chatlog_item: action.chatlog_item,
            messages: action.payload.chatLogs ? action.payload.chatLogs : [],
            chat_profile: action.payload.userProfileDetails ? action.payload.userProfileDetails : {}
          }
        },
        loaders: {
          ...state.loaders,
          active_chatlog_details_loading: false,
          active_chatlog_details_load_error: false,
        }
      };
    }

    case actionTypes.ACTIVE_CHATLOG_DETAILS_LOAD_ERROR: {
      return {
        ...state,
        user_profile: {
          ...state.user_profile,
          active_chatlog_details: {
            visible: false,
            chatlog_item: null,
            messages: [],
            chat_profile: {},
          }
        },
        loaders: {
          ...state.loaders,
          active_chatlog_details_loading: false,
          active_chatlog_details_load_error: true,
        }
      };
    }

    case GLOBAL_UPDATE_MESSAGE: {
      if (action.payload.psid && action.payload.chatlogId && action.payload.changedValue && state.user_profile.active_chatlog_details.chatlog_item && state.user_profile.active_chatlog_details.chatlog_item.psid === action.payload.psid) {
        let messages = [...state.user_profile.active_chatlog_details.messages];
        const index = messages.findIndex(message => (message.chatlogId && message.chatlogId === action.payload.chatlogId));
        if (index !== -1) {
          messages = [
            ...state.user_profile.active_chatlog_details.messages.slice(0, index),
            {
              ...messages[index],
              ...action.payload.changedValue
            },
            ...state.user_profile.active_chatlog_details.messages.slice(index + 1)
          ];
        }
        return {
          ...state,
          user_profile: {
            ...state.user_profile,
            active_chatlog_details: {
              ...state.user_profile.active_chatlog_details,
              messages,
            }
          },
        };
      }
    }

    default:
      return state;
  }
}

export default users_details;



// WEBPACK FOOTER //
// ./src/data/redux/users_details/reducers.js